<template>
  <div class="quotation">
    <div class="col-md-12 m-b">
      <div class="b-light">
        <div class="container">
          <ul class="m-t-md h5 breadcrumb no-border bg-empty m-b-none m-l-n-sm">
            <li>
              <a href="#">การขาย</a>
            </li>
            <li class="active">
              <span class="text-success h4">สร้างใบเสนอราคา</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="content" style=" padding-top:20px;padding-bottom:40px;">
      <div class="col-md-12 m-b-lg" style="margin-top:20px;margin-bottom:60px;">
        <div class="col-md-6 m-t-md">
          <a href="/quotation_personal">
            <div class="card">
              <div class="header">
                <img src="../assets/images/pic_general.jpg" alt style="height:350px;" />
              </div>
              <div class="ft-header center" style="bacground-color:#fff;">
                <h2 class="center">สำหรับรายบุคคล</h2>
              </div>
            </div>
          </a>
        </div>

        <div class="col-md-6 m-t-md">
          <!-- filter: grayscale(1);-webkit-filter: grayscale(100%) cursor: not-allowed; -->
          <router-link to="type_family">
            <div class="card">
              <div class="header">
                <img
                  src="../assets/images/pic_family.jpg"
                  alt
                  style="height:350px; max-width: 420px; object-fit: cover;"
                />
              </div>
              <div class="ft-header center" style="bacground-color:#fff;">
                <h2 class="center">สำหรับครอบครัว</h2>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'quotation',
  data() {
    return {}
  },
  computed: {},
  components: {},
  methods: {},
}
</script>

<style lang="scss"></style>
